import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import ClientSidebar from "components/Sidebar/Clientsidebar";
import UserRequest from "views/Profile";
import EditRequestForm from "views/me/updatedemande";
import StatutDemande from "views/me/statut";
import ContactForm from "views/me/contactus"
import Logout from "views/me/Logout";
// ... tes autres imports

export default function Me() {
  // Thème dans le parent (persisté)
  const [themeKey, setThemeKey] = useState(() =>
    localStorage.getItem("themeKey") || "light"
  );
  const [sidebarWidth, setSidebarWidth] = useState(
    window.innerWidth >= 992 ? 285 : 0
  );

  // Mise à jour du margin selon la largeur écran
  useEffect(() => {
    const handleResize = () => {
      setSidebarWidth(window.innerWidth >= 992 ? 285 : 0);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Pour passer le thème et le toggle
  const handleToggleTheme = () => {
    setThemeKey((prev) => {
      const newTheme = prev === "light" ? "dark" : "light";
      localStorage.setItem("themeKey", newTheme);
      return newTheme;
    });
  };

  return (
    <>
      <ClientSidebar themeKey={themeKey} onToggleTheme={handleToggleTheme} />
      <div
        style={{
          marginLeft: sidebarWidth,
          minHeight: "100vh",
          background: themeKey === "dark" ? "#22253a" : "#f6f7fb",
          transition: "background 0.22s, margin-left 0.22s",
          paddingTop: 40, 
        }}
      >
        <div className="px-4 md:px-10 mx-auto w-full mt-6">
          <Switch>
            <Route path="/me/" exact component={UserRequest} />
            <Route path="/me/modifier" exact component={EditRequestForm} />
            <Route path="/me/statut" exact component={StatutDemande} />
            <Route path="/me/contactus" exact component={ContactForm} />
            <Route path="/me/logout" exact component={Logout} />
            <Redirect from="/me/*" to="/login" />
          </Switch>
        </div>
      </div>
    </>
  );
}
